import { downloadFile } from '../../../shared/api/download';

export function downloadScreenshots(projectId: string, projectName: string): Promise<void> {
    const name = projectName.trim();
    return downloadFile(
        `/api/screenshots/download/${projectId}`,
        name ? `Скриншоты «${name}».zip` : `Скриншоты ${projectId}.zip`,
    );
}